import React, { useState, useEffect } from 'react';
import { getContent } from '../utils/api';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LegalPage = ({ type }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getContent()
      .then((content) => {
        setData(type === 'privacy' ? content.privacyPolicy : content.termsAndConditions);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-32 max-w-4xl">
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="w-10 h-10 border-4 border-amber-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : data ? (
          <article>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{data.title}</h1>
            {data.lastUpdated && (
              <p className="text-slate-400 text-sm mb-10 border-b border-slate-800 pb-6">
                Last Updated: {data.lastUpdated}
              </p>
            )}
            <div className="prose prose-invert max-w-none">
              {data.content.split('\n').map((line, i) => {
                // Section headings: "1. SECTION TITLE"
                if (/^\d+\.\s+[A-Z\s&]+$/.test(line.trim())) {
                  return (
                    <h2 key={i} className="text-xl font-bold text-amber-400 mt-10 mb-3">
                      {line}
                    </h2>
                  );
                }
                // Bullet points
                if (line.trim().startsWith('- ')) {
                  return (
                    <li key={i} className="text-slate-300 leading-relaxed ml-4 list-disc">
                      {line.trim().slice(2)}
                    </li>
                  );
                }
                // Empty line = paragraph break
                if (line.trim() === '') {
                  return <div key={i} className="mb-4" />;
                }
                // Regular paragraph
                return (
                  <p key={i} className="text-slate-300 leading-relaxed">
                    {line}
                  </p>
                );
              })}
            </div>
          </article>
        ) : (
          <p className="text-slate-400 text-center mt-20">Content not found.</p>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
